// import { createRouter, createWebHistory } from 'vue-router';
/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components
import App from './App.vue';
import "./date.extensions";
import { registerLicense } from '@syncfusion/ej2-base';
registerLicense("Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXtfd3RTQ2FfUUB1WUJWYEo=");


import { createVuetify } from 'vuetify';
import { de } from "vuetify/locale";
import router from '@/router'
// Composables

import { createApp } from 'vue'
// Plugins
import { registerPlugins } from '@/plugins'

import CommonBaseButtons from "@/components/common/BaseButtons.vue";
import './assets/vuetify-grid-reset.css';
import './assets/main.css';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { registerEditorComponents } from './editor/AllEditComponents';
import { registerAllViewComponents } from './views/AllViewComponents';
import { maskito } from '@maskito/vue';
import { initializeBarcodeWrapper } from './BarcodeScanWrapper';
import { installSpaDebug } from './SpaRouteDebugger';
import MyLog from './log';
// import { initPush } from '@/PushHelper';

MyLog.Current.Init();

const vuetify = createVuetify({
  components,
  directives,
  locale: {
    locale: 'de',
    fallback: 'en',
    messages: { de },
  },
  theme: {
    defaultTheme: 'light',
  },
  defaults: {
    VBtn: {
      class: 'text-uppercase',
      style: 'text-transform: uppercase;',
    },
  },
});
initializeBarcodeWrapper();

const app = createApp(App)
app.config.errorHandler = (err, vm, info) => {
  const error = err instanceof Error ? err : new Error(String(err));
  console.error("Global Error Handler:", {
    message: error.message,
    stack: error.stack,
    component: vm?.$options?.name ?? vm?.$?.type?.name,
    info,
  });
};
// Register Maskito directive globally
// You can call it 'maskito' or any other name you prefer, e.g., 'm-mask'
app.directive('maskito', maskito);

app.use(router)

if (ALLConfig.debug) {
  installSpaDebug(router);
}

registerPlugins(app)
registerEditorComponents(app);
registerAllViewComponents(app);

app.component('CommonBaseButtons', CommonBaseButtons);

app.use(vuetify).mount('#app')

declare var ALLConfig: ALLConfigType;


// Push Notifications: 

// ✅ Push-Notifications nach dem Mount initialisieren
//    (Service checkt selbst, ob native Plattform; im Browser passiert nichts)
// initPush({
//   navigate: (path) => router.push(path),
//   onToken: (t) => console.log('Push Token:', t),
//   // userId: store.user?.id, // optional: wenn du erst nach Login registrieren willst
// });
import "@/styles/disabled-override.css";